import { useCacheStore } from '@/stores/cache-store'
import { ttlService } from '../../services/ttl'

/**
 * Cache istatistiklerini döndürür
 * @returns {Object} Cache istatistikleri
 */
export const getStats = () => {
  const cacheStore = useCacheStore()
  const defaultTTL = "2m" // 2 dakika
  
  // Global istatistikler
  const globalStats = typeof window !== 'undefined' && window.__CACHE_STATS__ ? 
    window.__CACHE_STATS__ : 
    { hits: 0, misses: 0, sets: 0, invalidations: 0 }
  
  const hitRate = globalStats.hits + globalStats.misses > 0
    ? Math.round((globalStats.hits / (globalStats.hits + globalStats.misses)) * 100)
    : 0
  
  return {
    ...globalStats,
    hitRate: `${hitRate}%`,
    size: cacheStore.size(),
    memoryUsage: `${Math.round(cacheStore.estimatedSize() / 1024)} KB`,
    keys: cacheStore.keys(),
    defaultTTL: ttlService.format(ttlService.parse(defaultTTL))
  }
}